import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { buildStorefrontApiPath, api, resolveStorefrontOrgSlug } from "@/lib/api";
import type { PublicCategoryTreeNode, CategoryNode } from "@/lib/storefront-acl";
import {
  unwrapData,
  mapTreeNodeToCategory,
  ALL_CATEGORIES_NODE,
} from "@/lib/storefront-acl";

// Re-exports públicos para consumidores existentes
export type { CategoryNode, SubCat } from "@/lib/storefront-acl";

export async function fetchCategories(): Promise<CategoryNode[]> {
  const res = await api.get(buildStorefrontApiPath("/categories/tree"));
  const tree = unwrapData<PublicCategoryTreeNode[]>(res.data);

  const safeTree = Array.isArray(tree) ? tree : [];

  return [ALL_CATEGORIES_NODE, ...safeTree.map(mapTreeNodeToCategory)];
}

/**
 * H3 — una sola query del árbol para el header, el buscador y el inicio (antes
 * eran tres claves y dos GET en paralelo al arrancar, más un tercero al pintar
 * el inicio). La clave lleva el slug de la URL, como la del Navbar.
 */
export function useCategoryTree() {
  const { pathname } = useLocation();
  const match = pathname.match(/^\/s\/([^/]+)/i);
  const orgSlug =
    (match?.[1] ? decodeURIComponent(match[1]).trim().toLowerCase() : null) ||
    resolveStorefrontOrgSlug();
  return useQuery<CategoryNode[]>({
    queryKey: ["categories", orgSlug],
    queryFn: fetchCategories,
    staleTime: 5 * 60_000,
  });
}
